import { createModalsFactory } from 'ui';

import { DirectorySettingsModalIds, DirectorySettingsModalMeta } from './DirectorySettings.types';

const {
  Provider: DirectorySettingsModalProvider,
  useProvider: useDirectorySettingsModalProvider,
  ModalTitleWithBackButton,
} = createModalsFactory<DirectorySettingsModalIds[], DirectorySettingsModalMeta>([
  'base',
  'settings',
  // list families
  'families',
  // view family members
  'members',
  // Add or Edit family name
  'family',
  // Delete family
  'delete',
  // Add or Edit adult family member
  'backer-profile',
  // Remove adult from family
  'remove-adult',
  // Add or Edit child family member
  'child-profile',
  // Remove child from family
  'remove-child',
]);

export {
  DirectorySettingsModalProvider,
  ModalTitleWithBackButton,
  useDirectorySettingsModalProvider,
};
